<template>
  <div class="col-md-11 d-flex flex-column align-items-center justify-content-center router-view-background">
    <div v-if="user.attributes.kind === 'admin'" class="col-md-12 d-flex justify-content-between p-0 m-0">
      <div class="col-md-6 d-flex flex-column">
        <div class="col-md-12 px-2 pb-4">
          <v-autocomplete
            outlined
            label="Criador"
            item-text="name"
            item-value="id"
            :items="creators.map(e => ({...e, name:e.code_integration ? e.code_integration + ' - ' + e.name : e.name}))"
            v-model="service.person_id"
            @change="getFarms"
            no-data-text="Nenhum resultado..."
            :disabled="service.status && service.status === 'Em preenchimento'"
          ></v-autocomplete>
        </div>

        <div class="col-md-12 px-2">
          <v-autocomplete
            outlined
            label="Fazenda"
            item-text="name"
            item-value="id"
            :items="farms"
            :disabled="!service.person_id || service.status && service.status === 'Em preenchimento' && farms.length === 1"
            v-model="service.farm_id"
            no-data-text="Nenhum resultado..."
          ></v-autocomplete>
        </div>
      </div>

      <div class="col-md-6 d-flex flex-column">
        <div class="col-md-12 px-2 pb-4">
          <v-autocomplete
            outlined
            label="Controlador"
            item-text="name"
            item-value="id"
            :items="partners"
            v-model="service.partner_id"
            :disabled="!service.farm_id || user.attributes.kind === 'partner'"
            :error-messages="tried && user.attributes.kind !== 'partner' ? partnerErrors : ''"
            no-data-text="Nenhum resultado..."
          ></v-autocomplete>
        </div>

        <div class="col-md-12 px-2">
          <v-autocomplete
            outlined
            label="Tipo do Serviço"
            :items="serviceKinds"
            item-text="name"
            item-value="id"
            v-model="service.kind"
            :error-messages="tried && user.attributes.kind !== 'partner' ? typeErrors : ''"
            no-data-text="Nenhum resultado..."
          ></v-autocomplete>
        </div>
      </div>
    </div>

    <div v-else class="col-md-12 d-flex justify-content-between p-0 m-0">
      <div class="col-md-3">
        <v-autocomplete
          outlined
          label="Criador"
          item-text="name"
          item-value="id"
          :items="creators.map(e => ({...e, name:e.code_integration + ' - ' + e.name}))"
          v-model="service.person_id"
          @change="getFarms"
          no-data-text="Nenhum resultado..."
          :disabled="service.status && service.status === 'Em preenchimento'"
        ></v-autocomplete>
      </div>

      <div class="col-md-3">
        <v-autocomplete
          outlined
          label="Fazenda"
          item-text="name"
          item-value="id"
          :items="farms"
          :disabled="!service.person_id || service.status && service.status === 'Em preenchimento' && farms.length === 1"
          v-model="service.farm_id"
          no-data-text="Nenhum resultado..."
        ></v-autocomplete>
      </div>

      <div class="col-md-3">
        <v-autocomplete
          outlined
          label="Controlador"
          item-text="name"
          item-value="id"
          :items="partners"
          v-model="service.partner_id"
          :disabled="!service.farm_id || user.attributes.kind === 'partner'"
          :error-messages="tried && user.attributes.kind !== 'partner' ? partnerErrors : ''"
          no-data-text="Nenhum resultado..."
        ></v-autocomplete>
      </div>
    </div>

    <div v-if="hasSetFarm" class="col-md-12 mt-2 mb-0 d-flex justify-content-between"> 
      <div class="col-md-8 d-flex p-0">
        <v-select
          outlined
          label="Animais"
          item-text="name"
          item-value="id"
          return-object
          :items="animalsOptions"
          style="max-width:30%"
          @change="filterAnimals"
          v-model="animalsFilterValue"
          class="pr-1"
          :key="filterAnimalsTypekey"
        ></v-select>

        <!-- filtro de animais por nome e Brinco -->
        <v-text-field
          outlined
          label="Pesquisa"
          class="pl-1"
          style="max-width:59%"
          @input="searchAnimal"
          clearable
        ></v-text-field>
      </div>

      <v-btn v-if="$route.name === 'Edit-service'" @click="addingAnimal = true" class="buttonAdd"><i class="mdi mdi-plus pr-2"></i> Adicionar Animais</v-btn> 
    </div>

    <div v-if="this.allAnimals.length > 0" class="col-md-12 mb-6 d-flex align-items-center mb-2">
      <span>
        <strong style="color:var(--green)">{{computedParsedItemsFilter}}</strong>
        /
        <strong style="color:var(--green)">{{total_items}}</strong> 
        Registros
      </span>
      <div class="col-md-4 d-flex align-items-center ml-10">
        <p class="m-0 pr-2">Exibindo resultados :</p>
        <v-select
          outlined
          :items="valuesForAmount"
          item-text="title"
          item-value="value"
          :value="valuePerPage"
          @change="$_setAmount"
          style="max-width:100px; max-height:50px"
        ></v-select>
      </div>
    </div>
 
    <div class="col-md-12">
      <the-table 
        :key="tableKey"
        v-if="hasSetFarm"
        id="service-creation"
        :dataItems="computedAnimals"
        :headers="headersForTable"
        @sortable="sortableAnimals"
      >
       <template v-slot:switchAll>
          <v-switch
            inset
            color="success"
            @change="setCheckForAllAnimals"
            style="width:50px !important; height:30px; margin-left:20% !important"
            class="m-0"
            v-model="checkAllAnimals"
          ></v-switch>
        </template>

         <template v-slot:switch="{item}">
            <div class="d-flex flex-column align-items-center">
              <v-switch
                inset
                color="success"
                v-model="item.active"
                style="width:50px !important; height:30px; margin-left:20% !important"
                class="m-0 d-block"
                @change="service.id === undefined ? saveChange(item.active) : saveEditChange(item)"
              ></v-switch>
              <p class="text-center">{{item.observation}}</p>
            </div>
        </template>

        <template v-slot:animalRemove>
          <span class="d-flex justify-content-center">Remover do Serviço</span>
        </template>
        <template v-slot:remove="{item}">
          <v-switch
            inset
            color="success"
            style="width:50px !important; height:30px; margin-left:20% !important"
            class="m-0 d-block"
            @change="() => {!item.hide_modal ? removeAnimalFromService(item) : -1}"
            v-model="item.hide_modal"
          ></v-switch>
        </template>
      </the-table>
    </div>

    <div class="col-md-12 d-flex justify-content-end" style="margin-top:2vh" v-if="allAnimals.length">
      <v-pagination
        v-model="page"
        :length="total_pages"
        :total-visible="8"
        color="var(--jersey-yellow)"
      ></v-pagination>
    </div>

    <div class="col-md-12" style="margin-top:2vh">
      <the-actions
        color="#dfa006"
        sub-color="#ffffff"
        :action-text="this.$route.name === 'Edit-service' ? 'Salvar Serviço' :  'Gerar Serviço'"
        path-back="Services-list"
        :disabled="!hasSetFarm"
        :show-save="true"
        @save="confirm"
      />
    </div>

    <modal-add-animals 
      :isOpen="addingAnimal"
      :already-included="computedAnimals"
      :service="service"
      @close="closeAnimalsModal"
      @push-animal="updateAnimalsList"
    />

    <modal-confirmation 
      :confirm="showConfirmation"
      title="Confirmação"
      :text="'Tem certeza que deseja gerar serviço com ' + listStorage + ' animais ?'"
      @close="showConfirmation = false"
      @save="registerService"
    />

    <modal-remove-animal 
      :isOpen="showRemoveModal"
      :animal="animalToRemove"
      @close="closeRemoveModal"
      @get-observation="getObservation"
    />
  </div>
</template>

<script>
import TheActions from "@/components/layout/TheActions.vue";
import {mapState, mapActions} from "vuex";
import helpers from "@/mixins/helpers";
export default {
  name:"FormServices",
  components: { 
    TheTable: () => import("@/components/layout/TheTable.vue"),
    ModalAddAnimals: () => import("@/components/adm/services/ModalAddAnimals"),
    ModalConfirmation: () => import("@/components/layout/ModalConfirmation"),
    ModalRemoveAnimal: () => import("./ModalRemoveAnimal"),
    TheActions
  },
  mixins:[helpers],
  data() {
    return {
      service:{
        farm_id:null
      },
      tried:false, // campos obrigatórios só ficam vermelhos depois da primeira tentativa de salvar
      filterAnimalsTypekey:0,
      showConfirmation:false,
      headersForTable:[
        {text:"", value:"switch", has_slot:true, header_slot:"switchAll"},
        {text:"Animal", value:"name", sortable:true},
        {text:"Botton/Nro Particular", value:"code", sortable:true},
        {text:"Composição Racial", value:"degree_blood", sortable:true},
        {text:"Registro", value:"register", sortable:true},
        {text:"Data do Último Parto", value:"last_birthday", sortable:true},
        {text:"Data da Última Pesagem", value:"last_weight", sortable:true},
      ],
      selected_animal:null,
      addingAnimal:false,
      allAnimals:[],
      amount:50,
      tableKey:0,
      checkAllAnimals:true,
      animalsOptions:[
        {name:"N/D", id:0, params:"filter=N/D"},
        {name:"Liberados", id:1},
      ],
      groupAnimals:[],
      animalsFilterValue:{name:"Liberados", id:1},
      valuePerPage:50,
      valuesForAmount:[
        {title:"10", value:10},
        {title:"25", value:25},
        {title:"50", value:50},
        {title:"100", value:100},
      ],
      showRemoveModal:false,
      animalToRemove:{},
      listStorage:0
    }
  },
  computed: {
    ...mapState("creators", ["creators"]),
    ...mapState("farms", ["farms"]),
    ...mapState("login", ["user"]),
    ...mapState("partners", ["partners"]),
    ...mapState("service", ["service_single"]),
    serviceKinds() {
      return [
        {name:"Controle", id:"weight"},
        {name:"Supervisão", id:"view"},
      ]
    },
    computedTotalPages() {
     return Math.ceil(this.allAnimals.length / this.valuePerPage);
    },
    listSortCount() {
      if(this.allAnimals.length < this.amount) {
        return this.allAnimals.length;
      }
      if(this.computedAnimals.length > this.amount + 1) {
        return this.amount + this.computedAnimals.length; 
      }
      else {
        return this.amount;
      }
    },
    computedAnimals() {
      return this.allAnimals;
    },
    computedParsedItemsFilter() {
      return this.in_page > this.total_items ? this.total_items : this.in_page
    },
    computedGroups() {
      let groups = [];
      this.allAnimals.forEach(e => {
        if(e.group) {
          groups.push(e.group)
        }
      });
      let result = groups.filter((set => f => !set.has(f.id) && set.add(f.id))(new Set));
      return result;
    },
    hasSetFarm() {
      if(this.service.farm_id) {
        return true;
      } 
      else {
        return false;
      }
    },
    partnerErrors() {
      if(!this.service.partner_id || this.service.partner_id.length === 0) {
        return "Controlador é obrigatório";
      } else {
        return "";
      }
    },
    typeErrors() {
      if(!this.service.kind) {
        return "Tipo do Serviço é obrigatório";
      } else {
        return "";
      }
    }
  },
  methods: {
    ...mapActions("service", ["actionSaveService", "actionEditService", "actionGetSingleService"]),
    ...mapActions("animals", ["actionGetAnimalsReleased", "actionGetAllAnimals", "actionGetLastUsedAnimals"]),
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapActions("farms", ["actionGetFarms"]),
    ...mapActions("partners", ["actionGetPartners"]),
    async sortableAnimals(data) {
      this.allAnimals = [];
      const storage_list = JSON.parse(localStorage.getItem("form-create-service-list"));
      if(data) {
        let list = [];
        const results = await this.actionGetAnimalsReleased({headers:{farm:this.service.farm_id}, params:{order:data}});
        results.forEach(unused => {
          storage_list.forEach(e => {
            if(unused.id === e.id) {
              unused = e;
            }
          });
          list.push(unused);
        });
          this.allAnimals = [
            ...list
            .map(e => ({
              animal_id:e.id,
              id:e.id,
              name:e.name,
              code:e.code,
              active:e.active,
              last_birthday:e.last_birthday,
              last_weight:e.last_weight,
              is_edit:e.is_edit,
              search_key:e.register + " " + e.code + " " + e.name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
              observation:e.observation,
              hide_modal:true,
              register:e.register,
              degree_blood:e.degree_blood
            }))
          ];
      } else {
        this.allAnimals = [
          ...storage_list
          .map(e => ({
            animal_id:e.id,
            id:e.id,
            name:e.name,
            code:e.code,
            active:e.active,
            last_birthday:e.last_birthday,
            last_weight:e.last_weight,
            is_edit:e.is_edit,
            search_key:e.register + " " + e.code + " " + e.name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            observation:e.observation,
            hide_modal:true,
            register:e.register,
            degree_blood:e.degree_blood
          }))
        ];
      }
    },
    confirm() {
      if(
        this.user.attributes.kind !== "partner" && 
        !this.service.kind ||
        this.user.attributes.kind !== "partner" && 
        !this.service.partner_id
      ) {
        return 
      }
      let list = JSON.parse(localStorage.getItem('form-create-service-list'));
      this.showConfirmation = true;
      this.listStorage = list.filter(e => e.active === true && !e.observation?.length).length;
    },
    saveChange() {
      let list = JSON.parse(localStorage.getItem("form-create-service-list"));
      let newResults = [];
      list.forEach(storageItem => {
        this.allAnimals.forEach(animal => {
          if(storageItem.animal_id === animal.animal_id) {
            storageItem = animal;
          }
        });
        newResults.push(storageItem);
      });
      localStorage.setItem("form-create-service-list", JSON.stringify(newResults));
    },
    saveEditChange() {
      let list = JSON.parse(localStorage.getItem("form-create-service-list"));
      let newResults = [];
      list.forEach(storageItem => {
        this.allAnimals.forEach(animal => {
          if(storageItem.animal_id === animal.animal_id) {
            storageItem = {...animal, is_edit:true};
          }
        });
        newResults.push(storageItem);
      });
      localStorage.setItem("form-create-service-list", JSON.stringify(newResults));
    },
    closeRemoveModal() {
      this.showRemoveModal = false;
/*       this.allAnimals.forEach(e => {
        if(e.animal_id === animal.animal_id) {
          e.hide_modal = true;
        }
      })
      //update no localstorage
      const list = JSON.parse(localStorage.getItem("form-create-service-list"));
      list.forEach(e => {
        if(e.animal_id === animal.animal_id) {
          e.hide_modal = true;
        }
      });
      localStorage.setItem("form-create-service-list", 
        JSON.stringify(list.map(e => ({
          ...e, search_key:e.register + " " + e.code + " " + e.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        }))
      )); */
    },
    async registerService() {
      this.tried = true;
      if(!this.service.partner_id) {
        this.$toast.warning("Controlador é obrigatório");
        return
      }
      if(this.user.attributes.kind !== 'partner' && !this.service.kind) {
        this.$toast.warning("Tipo do Serviço é obrigatório");
        return
      }
      const animals = JSON.parse(localStorage.getItem("form-create-service-list"));
      this.service.service_animals_attributes = [
        ...animals
        .filter(e => e.is_edit === true)
        .map(e => ({
          animal_id:e.animal_id,
          observation:e.observation,
          id:e.id !== e.animal_id ? e.id : undefined,
          _destroy:(this.user.attributes.kind === "admin" && e.is_edit === true && e.active === false) ? true : undefined
        }))];
      try { 
        if(this.$route.name === "Edit-service") {
          await this.actionEditService(this.service);
        } 
        else {
          this.service.service_animals_attributes = [
            ...animals
            .filter(e => e.active === true)
            .map(e => ({animal_id:e.id ? e.id : e.animal_id, observation:e.observation}))
          ];
          await this.actionSaveService(this.service);
        }
        this.$toast.success(`Serviço ${this.$route.name === "Edit-service" ? "editado" : "cadastrado"} com sucesso`);
        this.$router.push({name:"Services-list"});
      } catch(error) {
        this.$toast.error(`${error}`);
      }
    },
    removeAnimalFromService(item) {
      this.showRemoveModal = true;
      this.animalToRemove = item;
    },
    //Esse metodo pegara o animal selecionado no modal e adicionará ele a table de pesagem
    updateAnimalsList(animal) {
      const list = JSON.parse(localStorage.getItem("form-create-service-list"));
      const newAnimal = {...animal, animal_id:animal.id, is_edit:true};
      delete newAnimal.id;
      list.push(newAnimal);
      localStorage.setItem("form-create-service-list", JSON.stringify(list));
      this.total_pages = Math.ceil(list.length / this.valuePerPage);
      this.total_items = list.length;
      this.allAnimals = list.filter((a,i) => i < this.valuePerPage);
      this.in_page = this.valuePerPage;
    },
    //Esse metodo pega as fazendas a partir do criador selecionado
    async getFarms() {
      this.animalsOptions = [
        {name:"N/D", id:0, params:"filter=N/D"},
        {name:"Liberados", id:1},
      ]
      await this.actionGetFarms(this.service.person_id);
    },
    //Esse metodo pega os controladores a partir da fazenda selecionada e os animals habilitados
    async getPartnerAndAnimals() {
      await this.actionGetPartners(this.service.farm_id);
      if(this.user.attributes.kind === "partner") {
        this.service.partner_id = this.partners.length ? this.partners.find(controler => controler.id === this.user.attributes.person_id).id : undefined;
      }
      let datesResult = await this.actionGetLastUsedAnimals({farm:this.service.farm_id});
      if(datesResult.dates.length) {
        datesResult.dates.forEach(e => {
          this.animalsOptions.push({name:e, id:e, date:true})
        })
      }
      this.filterAnimalsTypekey = this.filterAnimalsTypekey + 1;
      this.filterAnimals({id:1});
      this.animalsFilterValue.id = 1;
    },
    //Esse metodo configura todos os check dos animais para true
    setCheckForAllAnimals() {
      this.allAnimals.forEach(e => {
        e.active = this.checkAllAnimals;
      })
      this.tableKey = this.tableKey + 1;
      let list = JSON.parse(localStorage.getItem("form-create-service-list"));
      list.forEach(e => {
        e.active = this.checkAllAnimals;
      });
      localStorage.setItem("form-create-service-list", JSON.stringify(list));
    },
    closeAnimalsModal() {
      this.addingAnimal = false;
    },
    //Esse emtodo vai filtrar os animais de acordo com a preferência do usuário
   async filterAnimals(value) {
      this.allAnimals = [];
      if(value.id === 1) {
        let animalList = await this.actionGetAnimalsReleased({headers:{farm:this.service.farm_id}});
        if(animalList.length) {
          this.allAnimals = [
            ...animalList.filter(e => /^f/i.test(e.gender || ""))
            .map(e => ({...e, animal_id:e.id, search_key:e.register + " " + e.code + " " + e.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}))
          ];
          localStorage.setItem("form-create-service-list", JSON.stringify(this.allAnimals.map(e => ({...e, search_key:e.register + " " + e.code + " " + e.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}))));
          this.total_pages = Math.ceil(this.allAnimals.length / this.valuePerPage);
          this.total_items = this.allAnimals.length;
          this.allAnimals = this.allAnimals.filter((a,i) => i < this.valuePerPage);
          this.in_page = this.valuePerPage;
        }
      }
      if(value.date) {
         let animalList = await this.actionGetLastUsedAnimals({farm:this.service.farm_id, service_date:value.name});
         if(animalList.length) {
          this.allAnimals = [...animalList.map(e => ({...e, animal_id:e.id, search_key:e.register + " " + e.code + " " + e.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}))];
         }
      }
      if(value.id === 0){
        const animals_for_group = await this.actionGetAnimalsReleased({headers:{farm:this.service.farm_id}, params:{filter:"N/D"}});
        this.groupAnimals = [...animals_for_group.filter(e => /^f/i.test(e.gender || ""))];
        if(this.groupAnimals.length) {
          this.allAnimals = [...this.groupAnimals.map(e => ({...e, animal_id:e.id, search_key:e.register + " " + e.code + " " + e.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}))];
        }
        localStorage.setItem("form-create-service-list", JSON.stringify(this.allAnimals.map(e => ({...e, search_key:e.register + " " + e.code + " " + e.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}))));
        this.total_pages = Math.ceil(this.allAnimals.length / this.valuePerPage);
        this.total_items = this.allAnimals.length;
        this.allAnimals = this.allAnimals.filter((a,i) => i < this.valuePerPage);
        this.in_page = this.valuePerPage;
      }
  },
    //Esse metodo faz a pesquisa do animais
    searchAnimal(data) {
      if(data && data.length) {
        const list = JSON.parse(localStorage.getItem("form-create-service-list"))
        const finded = list.filter(e => e.search_key.toLowerCase().includes(data) || e.search_key.includes(data));
        this.allAnimals = finded;
        this.total_pages = Math.ceil(this.allAnimals.length / this.valuePerPage);
        this.total_items = this.allAnimals.length;
        this.in_page = this.valuePerPage;
      } else {
        this.resetSearch();
      }
    },
    //Esse metodo reseta a listagem 
    async resetSearch() {
      if(this.service_single.service_animals?.length) {
        const animalsReleased = await this.actionGetAnimalsReleased({headers:{farm:this.service_single.farm.id}});
        let list = [];
        animalsReleased.forEach(unused => {
          unused.animal = {...unused, active:false}
          this.service_single.service_animals.forEach(e => {
            if(unused.id === e.animal.id) {
              unused = {...e, is_edit:true};
            }
          })
          list.push(unused);
        });
        this.allAnimals = [
          ...list
          .map(e => ({
            animal_id:e.animal.id,
            id:e.id,
            name:e.animal.name,
            code:e.animal.code,
            active:e.animal.active,
            last_birthday:e.animal.last_birthday,
            last_weight:e.animal.last_weight,
            is_edit:e.is_edit,
            search_key:e.animal.register + " " + e.animal.code + " " + e.animal.name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            observation:e.observation,
            hide_modal:true,
            register:e.animal.register,
            degree_blood:e.animal.degree_blood,
          }))
        ];
        this.total_pages = Math.ceil(this.allAnimals.length / this.valuePerPage);
        this.total_items = this.allAnimals.length;
        this.allAnimals = this.allAnimals.filter((a,i) => i < this.valuePerPage);
        this.in_page = this.valuePerPage;
      } else {
        this.filterAnimals(this.animalsFilterValue);
      }
    },
    getObservation(data) {
      this.computedAnimals.forEach(animal =>  {
        if(animal.id === data.animal.id) {
          animal.active = false;
          animal.observation = data.reason;
        }
      });
      localStorage.setItem("form-create-service-list", JSON.stringify(this.computedAnimals));
    },
    checkLastBirth() {
      const serviceDate = Math.round(new Date(this.service_single.date).getTime() / 1000);
      this.allAnimals.forEach(e => {  
        const [day,month,year] = e.last_weight.split("-");
        const lastControl =  Math.round(new Date(year+"-"+month+"-"+day).getTime() / 1000);
        if((serviceDate - lastControl) < 1296000) {
          e.observation = "Intervalo do ultimo controle inferior a 15 dias";
        }
      })
      localStorage.setItem("form-create-service-list", JSON.stringify(this.allAnimals));
    }
  },
  watch: {
    farms(val) {
      if(val.length === 1) {
        this.service.farm_id = val[0].id;
      }
    },
    "service.farm_id": async function() {
      if(!this.$route.params.id) {
        await this.getPartnerAndAnimals();
      }
    },
    allAnimals() {
      if(this.$route.name === "Edit-service" && this.service_single.date) {
        this.checkLastBirth();
      }
    }
  },
  async mounted() {
    localStorage.setItem("form-create-service-list", JSON.stringify([]));
    if(this.$route.params.id) {
      await this.actionGetSingleService(this.$route.params.id);
      this.service = {
        id:this.service_single.id,
        person_id:this.service_single.person.id,
        farm_id:this.service_single.farm.id,
        partner_id:this.service_single.partner.id,
        status:this.service_single.status,
        kind:this.service_single.kind
      };
      await this.getFarms();
      await this.actionGetPartners(this.service.farm_id);
      if(this.service_single.service_animals.length) {
        const animalsReleased = await this.actionGetAnimalsReleased({headers:{farm:this.service_single.farm.id}});
        let list = [];
        animalsReleased.forEach(unused => {
          unused.animal = {...unused, active:false};
          this.service_single.service_animals.forEach(e => {
            if(unused.id === e.animal.id) {
              unused = {...e, is_edit:true};
            }
          });
          list.push(unused);
        });
        this.allAnimals = [
          ...list
          .map(e => ({
            animal_id:e.animal.id,
            id:e.id,
            name:e.animal.name,
            code:e.animal.code,
            active:e.animal.active,
            last_birthday:e.animal.last_birthday,
            last_weight:e.animal.last_weight,
            is_edit:e.is_edit,
            search_key:e.animal.register + " " + e.animal.code + " " + e.animal.name.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            observation:e.observation,
            hide_modal:true,
            register:e.animal.register,
            degree_blood:e.animal.degree_blood,
          }))
        ];
        localStorage.setItem("form-create-service-list", JSON.stringify(this.allAnimals));
        this.total_pages = Math.ceil(this.allAnimals.length / this.valuePerPage);
        this.total_items = this.allAnimals.length;
        this.allAnimals = this.allAnimals.filter((a,i) => i < this.valuePerPage);
        this.in_page = this.valuePerPage;
      } else {
        localStorage.setItem("form-create-service-list", JSON.stringify([]));
        this.total_pages = Math.ceil(0);
        this.total_items = 0;
        this.allAnimals = [];
        this.in_page = 1;
      }
    }
    await this.actionGetCreators();
    if(this.user.attributes.kind === "partner" && this.$route.name === "Edit-service"){
      this.headersForTable.splice(0,1);
      this.headersForTable.unshift({text:"", value:"remove", has_slot:true, header_slot:"animalRemove"});
    }
  }
}
</script>
